/* eslint-disable @typescript-eslint/no-explicit-any, unused-imports/no-unused-vars */
"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useMemo } from "react";
import { useRouter } from "next/navigation";
import kebabCase from "lodash/kebabCase";
import { getProductDietaryCategories, getAvailableFlavors, getInitialFormData, calculatePrice } from "@/utils/product/detail";
import { DietaryCategory } from "@/types/product";
import { ProductGallery, ProductHeader, CustomizationModal } from "@/components/product/details/ProductDetailView/sections";
import { useCheckout } from "@/contexts/checkout";
import ProductForm from "./sections/ProductForm";
import Breadcrumb from "@/components/common/breadcrumb";
import { getCartItemUniqueId } from "@/utils/cart";
import ContactSection from "@/components/ContactSection";
const ProductDetailView = t0 => {
  const $ = _c(91);
  const {
    product,
    allDietaryCategories
  } = t0;
  let t1;
  if ($[0] !== product) {
    t1 = getAvailableFlavors(product);
    $[0] = product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const availableFlavors = t1;
  let t2;
  if ($[2] !== product) {
    t2 = () => getInitialFormData(product);
    $[2] = product;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [formData, setFormData] = useState(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      isOpen: false,
      isBuyNowAction: false
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [customizationModalConfig, setCustomizationModalConfig] = useState(t3);
  const {
    addProduct
  } = useCheckout();
  const router = useRouter();
  formData?.selectedVariant;
  let t4;
  bb0: {
    if (!product) {
      t4 = 0;
      break bb0;
    }
    if (Array.isArray(product.weight_variants) && product.weight_variants.length > 0) {
      const selectedVariant = formData?.selectedVariant;
      if (selectedVariant?.preparation_time_minutes) {
        t4 = selectedVariant.preparation_time_minutes / 60;
        break bb0;
      }
    }
    t4 = product.preparation_time_minutes / 60 || 0;
  }
  const prepTimeHours = t4;
  let t5;
  if ($[5] !== formData || $[6] !== product) {
    t5 = calculatePrice(formData, product);
    $[5] = formData;
    $[6] = product;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const currentPrice = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setFormData(_temp);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const toggleEggless = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = message => {
      setFormData(prev_0 => ({
        ...prev_0,
        selectedMessage: message
      }));
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleMessageChange = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = name => {
      setFormData(prev_1 => ({
        ...prev_1,
        customizedName: name
      }));
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleCustomizedNameChange = t8;
  let t9;
  if ($[11] !== product.is_theme_cake || $[12] !== product.weight_variants) {
    t9 = flavor => {
      setFormData(prev_2 => {
        const updatedFormData = {
          ...prev_2,
          selectedFlavor: flavor
        };
        if (product?.is_theme_cake) {
          let matchingVariant = product.weight_variants.find(variant => variant.weight === prev_2.selectedVariant?.weight && variant.flavour?.id === flavor.id);
          if (!matchingVariant) {
            matchingVariant = product.weight_variants.find(variant_0 => variant_0.flavour?.id === flavor.id);
          }
          if (matchingVariant) {
            updatedFormData.selectedVariant = matchingVariant;
          }
        }
        return updatedFormData;
      });
    };
    $[11] = product.is_theme_cake;
    $[12] = product.weight_variants;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleFlavorChange = t9;
  let t10;
  if ($[14] !== formData.count) {
    t10 = () => {
      if (formData.count < 10) {
        setFormData(_temp2);
      }
    };
    $[14] = formData.count;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const incrementCount = t10;
  let t11;
  if ($[16] !== formData.count) {
    t11 = () => {
      if (formData.count > 1) {
        setFormData(_temp3);
      }
    };
    $[16] = formData.count;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const decrementCount = t11;
  let t12;
  if ($[18] !== addProduct || $[19] !== product || $[20] !== router) {
    t12 = async t13 => {
      const {
        item,
        isBuyNowAction: t14
      } = t13;
      const isBuyNowAction = t14 === undefined ? false : t14;
      await addProduct({
        product: {
          ...item,
          final_price_calculated: calculatePrice(item, product),
          vendor_details: product.vendor_details,
          gst_rate: product.gst_rate,
          slug: product.slug,
          uniqueId: getCartItemUniqueId(item),
          product_type_name: product.product_type_details?.name,
          product_subtype_name: product.product_subtype_details?.name,
          availableWeightVariantsCount: product?.weight_variants?.length || 0
        },
        isBuyNowAction
      });
      router.push(isBuyNowAction ? "/checkout" : `/${product.vendor_details.slug}/${product.vendor}`);
      setFormData(getInitialFormData(product));
    };
    $[18] = addProduct;
    $[19] = product;
    $[20] = router;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const handleAddToCart = t12;
  let t13;
  if ($[22] !== handleAddToCart || $[23] !== product.customization_info?.length || $[24] !== product.weight_variants?.length) {
    t13 = t14 => {
      const {
        item: item_0,
        isBuyNowAction: t15
      } = t14;
      const isBuyNowAction_0 = t15 === undefined ? false : t15;
      const hasCustomization = product?.customization_info?.length > 0;
      const hasMultipleWeights = product?.weight_variants?.length > 1;
      if (hasCustomization || hasMultipleWeights) {
        setCustomizationModalConfig({
          isOpen: true,
          isBuyNowAction: isBuyNowAction_0
        });
        return;
      }
      handleAddToCart({
        item: item_0,
        isBuyNowAction: isBuyNowAction_0
      });
    };
    $[22] = handleAddToCart;
    $[23] = product.customization_info?.length;
    $[24] = product.weight_variants?.length;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const handleAddItem = t13;
  let t14;
  if ($[26] !== allDietaryCategories || $[27] !== product.dietary_categories) {
    t14 = getProductDietaryCategories({
      allDietaryCategories: allDietaryCategories || [],
      productDietaryCategoryIds: product.dietary_categories || []
    });
    $[26] = allDietaryCategories;
    $[27] = product.dietary_categories;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const dietaryCategories = t14;
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      label: "Home",
      link: "/"
    };
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== product.vendor || $[31] !== product.vendor_details) {
    t16 = product.vendor_details?.business_name && {
      label: product.vendor_details.business_name,
      link: `/${product.vendor_details.slug}/${product.vendor}`
    };
    $[30] = product.vendor;
    $[31] = product.vendor_details;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== product.category) {
    t17 = product.category && {
      label: product.category,
      link: `/category/${kebabCase(product.category)}`
    };
    $[33] = product.category;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== product.name) {
    t18 = product.name && {
      label: product.name
    };
    $[35] = product.name;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t17 || $[39] !== t18) {
    t19 = [t15, t16, t17, t18].filter(Boolean);
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  const breadcrumbItems = t19;
  let t20;
  if ($[41] !== breadcrumbItems) {
    t20 = <div className="hidden lg:block pt-6"><Breadcrumb items={breadcrumbItems} /></div>;
    $[41] = breadcrumbItems;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  let t22;
  if ($[43] !== formData || $[44] !== handleAddItem) {
    t21 = () => handleAddItem({
      item: formData
    });
    t22 = () => handleAddItem({
      item: formData,
      isBuyNowAction: true
    });
    $[43] = formData;
    $[44] = handleAddItem;
    $[45] = t21;
    $[46] = t22;
  } else {
    t21 = $[45];
    t22 = $[46];
  }
  let t23;
  if ($[47] !== decrementCount || $[48] !== formData || $[49] !== incrementCount || $[50] !== product || $[51] !== t21 || $[52] !== t22) {
    t23 = <div className="w-full flex justify-center lg:justify-end min-w-0"><ProductGallery product={product} formData={formData} onIncrement={incrementCount} onDecrement={decrementCount} onAddToCart={t21} onBuyNow={t22} /></div>;
    $[47] = decrementCount;
    $[48] = formData;
    $[49] = incrementCount;
    $[50] = product;
    $[51] = t21;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  const t24 = product?.vendor;
  let t25;
  let t26;
  if ($[54] !== formData || $[55] !== handleAddItem) {
    t25 = () => handleAddItem({
      item: formData
    });
    t26 = () => handleAddItem({
      item: formData,
      isBuyNowAction: true
    });
    $[54] = formData;
    $[55] = handleAddItem;
    $[56] = t25;
    $[57] = t26;
  } else {
    t25 = $[56];
    t26 = $[57];
  }
  let t27;
  if ($[58] !== currentPrice || $[59] !== decrementCount || $[60] !== dietaryCategories || $[61] !== formData || $[62] !== incrementCount || $[63] !== prepTimeHours || $[64] !== product || $[65] !== t24 || $[66] !== t25 || $[67] !== t26) {
    t27 = <ProductHeader product={product} currentPrice={currentPrice} dietaryCategories={dietaryCategories} formData={formData} onIncrement={incrementCount} onDecrement={decrementCount} vendorId={t24} prepTimeHours={prepTimeHours} onAddToCart={t25} onBuyNow={t26} handleCustomizedNameChange={handleCustomizedNameChange} />;
    $[58] = currentPrice;
    $[59] = decrementCount;
    $[60] = dietaryCategories;
    $[61] = formData;
    $[62] = incrementCount;
    $[63] = prepTimeHours;
    $[64] = product;
    $[65] = t24;
    $[66] = t25;
    $[67] = t26;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="hidden lg:block w-full"><ContactSection /></div>;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== availableFlavors || $[71] !== formData || $[72] !== handleFlavorChange || $[73] !== product) {
    t29 = <div className="w-full lg:overflow-y-auto no-scrollbar space-y-6 max-lg:pt-5 flex-1 flex flex-col mt-6"><ProductForm product={product} formData={formData} toggleEggless={toggleEggless} handleFlavorChange={handleFlavorChange} handleMessageChange={handleMessageChange} handleCustomizedNameChange={handleCustomizedNameChange} availableFlavors={availableFlavors} /></div>;
    $[70] = availableFlavors;
    $[71] = formData;
    $[72] = handleFlavorChange;
    $[73] = product;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== t27 || $[76] !== t29) {
    t30 = <div className="flex flex-col w-full justify-start lg:h-auto min-h-[600px] relative z-10 overflow-hidden min-w-0">{t27}{t28}{t29}</div>;
    $[75] = t27;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== customizationModalConfig.isBuyNowAction || $[79] !== customizationModalConfig.isOpen || $[80] !== formData || $[81] !== handleAddToCart || $[82] !== product) {
    t31 = customizationModalConfig.isOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 backdrop-blur-sm !m-0" onClick={() => {
      setCustomizationModalConfig({
        isOpen: false,
        isBuyNowAction: false
      });
    }}><div onClick={_temp4} className="h-full w-full flex flex-col justify-end sm:justify-center items-center pt-14 sm:pt-0 sm:p-4"><CustomizationModal onClose={() => {
          setCustomizationModalConfig({
            isOpen: false,
            isBuyNowAction: false
          });
        }} product={product} formData={formData} onFormDataChange={setFormData} onAddToCart={data => handleAddToCart({
          item: data,
          isBuyNowAction: customizationModalConfig.isBuyNowAction
        })} renderHeaderContent={_temp5} isBuyNow={customizationModalConfig.isBuyNowAction} availableWeightVariantsCount={product?.weight_variants?.length || 0} /></div></div>;
    $[78] = customizationModalConfig.isBuyNowAction;
    $[79] = customizationModalConfig.isOpen;
    $[80] = formData;
    $[81] = handleAddToCart;
    $[82] = product;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== t23 || $[85] !== t30 || $[86] !== t31) {
    t32 = <div className="mt-6 lg:mt-10 grid grid-cols-1 lg:grid-cols-2 lg:gap-12 gap-6 w-full items-start">{t23}{t30}{t31}</div>;
    $[84] = t23;
    $[85] = t30;
    $[86] = t31;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t20 || $[89] !== t32) {
    t33 = <div className="w-full max-w-[1440px] mx-auto px-4 lg:px-8 xl:px-12 relative overflow-x-clip">{t20}{t32}</div>;
    $[88] = t20;
    $[89] = t32;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  return t33;
};
export default ProductDetailView;
function _temp(prev) {
  return {
    ...prev,
    isEggless: !prev.isEggless
  };
}
function _temp2(prev_3) {
  return {
    ...prev_3,
    count: prev_3.count + 1
  };
}
function _temp3(prev_4) {
  return {
    ...prev_4,
    count: prev_4.count - 1
  };
}
function _temp4(e) {
  return e.stopPropagation();
}
function _temp5() {
  return null;
}